import { gql } from '@apollo/client'

export const GET_DRIVERS_SUGGESTIONS = gql`
  query GetDriversSuggestions($input: DriverSuggestionsInput!) {
    driverSuggestions(input: $input) {
      items {
        id
        name
      }
    }
  }
`

export const GET_DRIVER = gql`
  query GetDriver($input: TDriverInput!) {
    tdriver(input: $input) {
      id
      partner {
        id
        name
      }
      userAccount {
        id
        firstName
        lastName
        email
        phoneNumber {
          number
          countryCode
        }
        gender
      }
      stateCode
      documents {
        document {
          name
          path
        }
        category
      }
    }
  }
`
